import request from '@/utils/request'

// 查询部门列表
export function listDept() {
  return request({
    url: '/api/free/systdept/list',
    method: 'get',
  })
}

// 异步加载组织结构树
export function asyncTreeselect(data) {
  return request({
    url: '/api/free/systdept/asyncTreeselect',
    method: 'post',
    data: data
  })
}

/**
 * 根据部门编码查询部门信息
 * @param deptCode
 * @param type 其中type=tree表示返回AsyncTreeSelect，type=dept表示返回SysDept
 */
export function getDeptByCode(deptCode,type) {
  return request({
    url: '/api/free/systdept/getInfoByCode/' + deptCode + '/' + type,
    method: 'get'
  })
}

export function getListDept(query) {
  return request({
    url: '/web/sysdept/list',
    method: 'get',
    params: query
  })
}
